module.exports = __webpack_public_path__ + "static/img/0541_4.00b52e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_4.jpg
// module id = K5N0
// module chunks = 1